import React from "react";
import LegalPage from "./LegalPage";

export default function TermsConditions() {
  return <LegalPage kind="terms" />;
}
